import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'

import EventedBrowserRouter from 'cogsworth/routing/EventedBrowserRouter'

import BookingPage from 'cogsworth/pages/BookingPage/BookingPage'
import RatingPage from 'cogsworth/pages/RatingPage/RatingPage'
import NotFoundPage from 'cogsworth/pages/NotFoundPage/NotFoundPage'

class BookingRouter extends Component {
  render() {
    return (
      <EventedBrowserRouter basename="/book">
        <Switch>
          <Route path="/:id/:token?" exact component={BookingPage} />
          <Route path="/rate/:id/:token" exact component={RatingPage} />
          <Route component={NotFoundPage} />
        </Switch>
      </EventedBrowserRouter>
    )
  }
}

export default BookingRouter
